export const CONSENT_VERSION = '2026-06';
export const AI_CONSENT_STORAGE_KEY = 'aaa_ai_consent';
export const AI_CONSENT_EVENT = 'aaa:ai-consent-changed';

const isBrowser = () =>
  typeof window !== 'undefined' && typeof window.localStorage !== 'undefined';

/**
 * @returns {{accepted: boolean, version: string, ts: string} | null}
 */
export const getStoredConsent = () => {
  if (!isBrowser()) return null;
  try {
    const raw = window.localStorage.getItem(AI_CONSENT_STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== 'object') return null;
    return parsed;
  } catch {
    return null;
  }
};

export const hasValidAiConsent = () => {
  const stored = getStoredConsent();
  return !!stored && stored.accepted === true && stored.version === CONSENT_VERSION;
};

const emitConsentChange = () => {
  if (!isBrowser()) return;
  try {
    window.dispatchEvent(new Event(AI_CONSENT_EVENT));
  } catch {
    /* no-op */
  }
};

export const recordLocalConsent = () => {
  if (!isBrowser()) return;
  try {
    const record = {
      accepted: true,
      version: CONSENT_VERSION,
      ts: new Date().toISOString(),
    };
    window.localStorage.setItem(AI_CONSENT_STORAGE_KEY, JSON.stringify(record));
    emitConsentChange();
  } catch {
  }
};

export const clearLocalConsent = () => {
  if (!isBrowser()) return;
  try {
    window.localStorage.removeItem(AI_CONSENT_STORAGE_KEY);
    emitConsentChange();
  } catch {
    /* no-op */
  }
};

export const subscribeToConsentChanges = (callback) => {
  if (!isBrowser()) return () => {};
  const handler = () => callback();
  const storageHandler = (event) => {
    if (event.key === AI_CONSENT_STORAGE_KEY || event.key === null) callback();
  };
  window.addEventListener(AI_CONSENT_EVENT, handler);
  window.addEventListener('storage', storageHandler);
  return () => {
    window.removeEventListener(AI_CONSENT_EVENT, handler);
    window.removeEventListener('storage', storageHandler);
  };
};
